import React, {useEffect, useRef} from 'react'

export default function SearchList({
    validate, 
    valueListDefined, 
    statusValueLetter, 
    valueLetter, 
    statusValueList, 
    valueList, 
    customOnClick,
    style,
    colLg
}) {

    const wrapperRef = useRef(null);
    useOutsideAlerter(wrapperRef);

    function useOutsideAlerter(ref) {
      useEffect(() => {

        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) {
                statusValueList([])
            }
        }
      
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
      }, [ref]);
    }

    function searchableList(letter, list, statusLetter, statusList){
        let tipos = []
        if(letter !== ""){
            for(let i = 0; i < list.length; i++){
                let w = list[i]
                if(w.toLowerCase().includes(letter.toLowerCase())){
                  tipos.push(w)
                }else{
                    statusList([])
                    statusLetter(letter)
                }
            }
        statusList(tipos)
        }else{
            statusLetter("")
            statusList([])
        }
    }
    
    function valideteLetter(){
        var bool = false
        if(validate && !valueListDefined.includes(valueLetter) && valueLetter !== "") bool = true
        return bool
    }


    return (
        <div style={style} ref={wrapperRef} className={`${!colLg && "mt-3 col-lg-4"} px-0 custom-dropdown`}>
          <input placeholder={valueListDefined[0]} value={valueLetter} 
          onChange={(e)=>{ searchableList(e.target.value, valueListDefined, statusValueLetter, statusValueList) }} 
          className={`form-control ${valideteLetter() && "border-danger"}`}/>

          <div className="custom-dropdown-box">
            {valueList.map((val, i)=>{
                // let a = {
                //     val: val,
                //     body: i
                // }
                return (
                <div className="custom-dropdown-option cursor-pointer" onClick={()=>{ 
                    statusValueLetter(val); 
                    statusValueList([]);
                    customOnClick(val)
                }} key={i}>
                    {val}
                </div>
                )
            })}
          </div>
            { valideteLetter() && <p className="mb-0 error-text">Debes seleccionar una palabra de la lista</p> }
        </div>
    )
}
